import React, { useState, useMemo } from 'react';
import i18n from 'i18next';

import { useLanguage } from '../../contexts/LanguageContext';
import { useResto } from '../../contexts/RestoContext';
import config from '../../config/config';

const LanguageSelector = () => {

  const { activeLanguage, updateLanguage } = useLanguage();
  const { restoData } = useResto();
  const [showFlags, setShowFlags] = useState(false);

  // 🔹 Sécurisation
  const availableLanguages = useMemo(() => {
    return restoData?.availableLanguages || [];
  }, [restoData]);

  // 🔹 Pas d’affichage si une seule langue
  if (availableLanguages.length <= 1) {
    return null;
  }

  const handleLanguageChange = (lang) => {
    updateLanguage(lang);
    i18n.changeLanguage(lang);
    setShowFlags(false);
  };

  const toggleFlags = () => {
    setShowFlags(prev => !prev);
  };

  return (
    <div className={`language-selector mr-3 ${showFlags ? 'expanded' : ''}`}>

      {/* Langue active */}
      <span
        onClick={toggleFlags}
        className={`flag_icon ${showFlags ? 'flag_icon_active' : ''}`}
        style={{ cursor: 'pointer' }}
      >
        <img
          src={`${config.kubuniImagesUrl}general-icons/flag_${activeLanguage}_icon_24.png`}
          alt={activeLanguage}
        />
      </span>

      {/* Autres langues */}
      {showFlags && (
        <div
          className="flag-container vertical background-main-color-80"
          style={{
            color: 'white',
            padding: '0 0 5px'
          }}
        >
          {availableLanguages
            .filter(lang => lang !== activeLanguage)
            .map(lang => (
              <span
                key={lang}
                onClick={() => handleLanguageChange(lang)}
                className="flag_icon"
                style={{ cursor: 'pointer' }}
              >
                <img
                  src={`${config.kubuniImagesUrl}general-icons/flag_${lang}_icon_24.png`}
                  alt={lang}
                />
              </span>
            ))}
        </div>
      )}

    </div>
  );
};

export default LanguageSelector;